import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY } from '../constants';
import styles from './AboutPage.module.css';

const VALUES = [
  { icon: '✅', title: 'Verified Stock', desc: 'Every machine is physically inspected before listing.' },
  { icon: '🤝', title: 'Honest Pricing', desc: 'Transparent pricing with no hidden charges.' },
  { icon: '📞', title: 'Always Reachable', desc: 'Call or WhatsApp us — we respond fast.' },
  { icon: '🏭', title: 'Wide Inventory', desc: 'CNC, lathe, milling, grinding and more.' },
];

export default function AboutPage() {
  return (
    <div className={styles.page}>
      <div className={styles.hero}>
        <div className={styles.heroStripe} />
        <div className="container">
          <div className={styles.heroBadge}>About Us</div>
          <h1 className={styles.heroTitle}>BRIGHT <span className={styles.yellow}>MACHINERIES</span></h1>
          <p className={styles.heroSub}>Used Machine Seller · Navi Mumbai, Maharashtra</p>
        </div>
      </div>

      <div className="container">
        <div className={styles.content}>
          <div className={styles.textBlock}>
            <h2 className={styles.sectionTitle}>Who We Are</h2>
            <p className={styles.text}>
              Bright Machineries is a trusted dealer in used industrial machinery based in Navi Mumbai.
              We buy and sell a wide range of machines including CNC machining centres, lathe machines, milling
              machines, grinding machines, and more.
            </p>
            <p className={styles.text}>
              Our goal is simple: connect buyers and sellers of used machinery with complete transparency.
              Every machine in our yard is physically verified before being listed, so you always know
              exactly what you're getting.
            </p>
            <p className={styles.text}>
              Whether you're looking to upgrade your workshop or sell surplus equipment, we're here to help
              you get the right deal quickly and fairly.
            </p>
          </div>

          <div className={styles.valuesGrid}>
            {VALUES.map(v => (
              <div key={v.title} className={styles.valueCard}>
                <span className={styles.valueIcon}>{v.icon}</span>
                <h3 className={styles.valueTitle}>{v.title}</h3>
                <p className={styles.valueDesc}>{v.desc}</p>
              </div>
            ))}
          </div>

          <div className={styles.contactBar}>
            <div className={styles.contactInfo}>
              <p>📍 {COMPANY.address}</p>
              <p>📞 {COMPANY.phone}</p>
              <p>✉️ {COMPANY.email}</p>
              <p>🕐 {COMPANY.hours}</p>
            </div>
            <div className={styles.contactActions}>
              <Link to="/stock" className={styles.btnPrimary}>Browse Stock →</Link>
              <Link to="/contact" className={styles.btnSecondary}>Get in Touch</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
